import axios from 'axios';

export const getHeaders = (headers = {}) => {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'is-api-query': true,
        "X-Requested-With": "XMLHttpRequest",
        ...headers,
    }
};

export const getTimeout = () => {
    return 15000; // 15 seconds
};

export const xhrRequest = axios.create({
    baseURL: location.origin,
    headers: getHeaders(),
    withCredentials: false,
    timeout: getTimeout(),
});